import { render, staticRenderFns } from "./QuestionsPage.vue?vue&type=template&id=17f2aeae&"
import script from "./QuestionsPage.vue?vue&type=script&lang=js&"
export * from "./QuestionsPage.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports